module.exports = __webpack_public_path__ + "static/media/before-5-icon-1.e05b394c.svg";